export default __webpack_public_path__ + "static/assets/d93b3fbb26a6c63230cf52adeabbee15.png";